/**
 * Return a generator which returns an item from the provided
 * array each time it's called, going back to the beginning of
 * the array when it reaches the end
 */
export const arrayLooper = (arr) => {
  if (!(arr instanceof Array)) {
    throw `arrayLooper: argument must be an array`;
  }
  let count = 0;
  const iterator = {
    next() {
      const i = count % arr.length;
      count++;
      return arr[i];
    },
    first() {
      count = 1;
      return arr[0];
    },
  };
  return iterator;
};
